<template>
  <BreadCrumb PageTitle="Profil" />
  <AboutContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AboutContent from "../../components/Profile/About.vue";

export default defineComponent({
  name: "ProfilePage",
  components: {
    BreadCrumb,
    AboutContent,
  },
});
</script>